module.exports = __webpack_public_path__ + "media/Resources/Company-95296945.svg";